import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/primeng';
import {TransactionPurposeTypeService} from '../transaction-purpose-type.service';

@Component({
  selector: 'app-transaction-purpose-type',
  templateUrl: './transaction-purpose-type.component.html',
  styleUrls: ['./transaction-purpose-type.component.css'],
  providers:[TransactionPurposeTypeService]
})
export class TransactionPurposeTypeComponent implements OnInit {

  transactionPurposeType: string[];
  loading: boolean = false;
  msgs: Message[] = [];

  constructor( private transactionPurposeTypeService: TransactionPurposeTypeService,
              private router: Router 
              ) { }

              ngOnInit() {
                this.loading = true;
                this.transactionPurposeTypeService.getTransactionPurposeType().subscribe(response => {
                  this.transactionPurposeType=response['data'];
                  this.loading = false;
                });
             }
           
           
              add(){
                this.router.navigate(['dashboard/transaction-purpose-type-crud/']);
              } 
           
              edit(id: any){
                  this.router.navigate(['dashboard/transaction-purpose-type-crud/',id]);
             }
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/transaction_purpose_types/transaction-purpose-type/transaction-purpose-type.component.ts